import { render } from "./TurmaIndividual.vue?vue&type=template&id=4e1be06a&scoped=true"
import script from "./TurmaIndividual.vue?vue&type=script&lang=js"
export * from "./TurmaIndividual.vue?vue&type=script&lang=js"

import "./TurmaIndividual.vue?vue&type=style&index=0&id=4e1be06a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e1be06a"]])

export default __exports__